





























import Vue from 'vue';
import { HasTaskMixin } from 'mycorems-app-shared';
import { PaymentMethod } from '../types';
import repository from './payment-method-repository';
import PaymentMethodItem from './PaymentMethodItem.vue';

interface Data {
  paymentMethods: PaymentMethod[],
  task: Promise<PaymentMethod[]>|null,
}

export default Vue.extend({
  components: { PaymentMethodItem },
  mixins: [HasTaskMixin],
  model: {
    event: 'change',
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
    value: [String, Object as () => PaymentMethod],
    object: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      paymentMethods: [],
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.findAll(this.customerId);
      this.task.then((paymentMethods: PaymentMethod[]) => {
        this.paymentMethods = paymentMethods;
        if (!this.value) {
          this.selectPrimary();
        }
      });
    },
    select(paymentMethod: PaymentMethod|null) {
      let value:PaymentMethod|string|null = paymentMethod;
      if (paymentMethod) {
        value = (this.object) ? paymentMethod : paymentMethod.id;
      }
      this.$emit('change', value);
    },
    selectPrimary() {
      const primary = this.paymentMethods.find(pm => pm.isPrimary);
      if (primary) {
        this.select(primary);
      }
    },
    isObject(value: any) {
      return (typeof value === 'object' && value);
    },
  },
});
